(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

// Website wide scripts
// @Author INTO THE WHY https://itwhy.fr/
//var _ = require('lodash');


var current = 1;
var maxSlice = 0;
var currentDiapo = 1;
var time = false;
var galerieOpen = false;
var totalSlide = 0;
var currentGalerie;

//POP-UPS
function openPopup() {
  TweenLite.to('#pop-en', .4, {
    opacity: 1,
    display: "block"
  });
}

function closePopup() {
  TweenLite.to('#pop-en', .4, {
    opacity: 0,
    display: "none"
  });
}

function initPopup() {
  $('#pop').on('click', openPopup);
  $('.back').on('click', closePopup);
  $('#btn-close').on('click', closePopup);
}

//NAV-LEFT ET SCROLL-ANIMATION 
function scrollBarInit() {
  var nbrSection = $('.fs-section').length;
  maxSlice = nbrSection;
  var aside = $('aside ul');
  var asideConteneur = $('aside');
  //placement 
  var winY = window.innerHeight;
  //
  for (var i = 1; i <= nbrSection; i++) {
    aside.append('<li id="li' + i + '"data-id="' + i + '" class="point circle-on"><a><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 29.6 30.3" style="enable-background:new 0 0 29.6 30.3;" xml:space="preserve"><circle class="circle" cx="14.4" cy="15.7" r="10.7"/></svg></a></li>');
    var calc = 0;
    if (nbrSection == 3) {
      //$('aside').find("#li" + i).css('top', (((112 / (nbrSection)) * (i - 1))+10) + "%");
      $('aside').find("#li" + i).css('top', 38 * (i - 1) + 8 + "%");
      calc = 38;
    } else {
      $('aside').find("#li" + i).css('top', 25 * (i - 1) + 8 + "%");
      calc = 25;
    }

    $('aside').find("#li" + i).hover(function () {
      var tempTool = $('#tooltip').find('.tool' + this.dataset.id);
      $('#tooltip').css('top', calc * (this.dataset.id - 1) + 12.2 + "%");
      $('#tool' + this.dataset.id).addClass('shown');
    }, function () {
      $('#tool' + this.dataset.id).removeClass('shown');
    });
    $('aside').find("#li" + i).on('click', function () {
      var temp = this.dataset.id;
      pressAside(temp);
    });

    $('#tooltip').css('top', '0%');
  }
  $('aside #li1').find("circle").addClass('circle-on');
}

function pressAside(cible) {
  console.log("current = " + current + " cible = " + cible);
  $('aside #li' + cible).find("circle").addClass('circle-on');
  $('aside #li' + current).find("circle").removeClass('circle-on');
  $('aside #li' + current).find("circle").removeClass('circle');
  $('aside #li' + current).find("circle").addClass('circle-ok');

  if (cible > current) {

    //CONTENU QUI MONTE
    $('article').find('#section' + cible).css('top', '120%');
    TweenLite.to($('article').find('#section' + cible), 1, {
      delay: .2,
      ease: Power3.easeInOut,
      top: "65px"
    });
    TweenLite.to($('article').find('#section' + current), 1, {
      ease: Power3.easeInOut,
      top: "-120%"
    });
    //SHOW GALLERY
    //IF GALLERY EXIST, ANIM GALLERY
    if ($('.galerie').length == 1) {
      if (cible == 2) {

        $('.galerie').find('.slider').css('top', '100%');
        $('.galerie').find('.slider').css('bottom', '60px');
        TweenLite.to($('.galerie').find('.slider'), 1, {
          delay: .2,
          ease: Power2.easeInOut,
          top: "10%",
          onComplete: myFunction
        });
        TweenLite.to($('.galerie').find('.showGallery'), .3, {
          delay: 1,
          opacity: 1,
          display: "block"
        });
      }
      //HIDE GALLERY
      if (current == 2) {
        $('.galerie').find('.slider').removeClass('galleryTransition');
        TweenLite.to($('.galerie').find('.slider'), 1, {
          ease: Power2.easeInOut,
          bottom: "100%"
        });
        TweenLite.to($('.galerie').find('.showGallery'), .2, {
          opacity: 0,
          display: "none"
        });
      }
    }
    if ($('.galerie').length == 2) {
      if (cible == 2) {

        $('.galerie-domaine').find('.slider').css('top', '100%');
        $('.galerie-chateau').find('.slider').css('top', '100%');
        $('.galerie-domaine').find('.slider').css('bottom', '52%');
        $('.galerie-chateau').find('.slider').css('bottom', '65px');

        TweenLite.to($('.galerie-domaine').find('.slider'), 1, {
          delay: .2,
          ease: Power2.easeInOut,
          top: "10%",
          onComplete: myFunction
        });
        TweenLite.to($('.galerie-domaine').find('.showGallery'), .3, {
          delay: 1,
          opacity: 1,
          display: "block"
        });
        //
        TweenLite.to($('.galerie-chateau').find('.slider'), 1, {
          delay: .2,
          ease: Power2.easeInOut,
          top: "50%",
          onComplete: myFunction
        });
        TweenLite.to($('.galerie-chateau').find('.showGallery'), .3, {
          delay: 1,
          opacity: 1,
          display: "block"
        });
      }
      //HIDE GALLERY
      if (current == 2) {
        $('.galerie-chateau').find('.slider').removeClass('galleryTransition');
        TweenLite.to($('.galerie').find('.slider'), .6, {
          ease: Power2.easeInOut,
          bottom: "100%"
        });
        TweenLite.to($('.galerie-chateau').find('.showGallery'), .2, {
          opacity: 0,
          display: "none"
        });
        //
        $('.galerie-domaine').find('.slider').removeClass('galleryTransition');
        TweenLite.to($('.galerie').find('.slider'), .6, {
          ease: Power2.easeInOut,
          bottom: "100%"
        });
        TweenLite.to($('.galerie-domaine').find('.showGallery'), .2, {
          opacity: 0,
          display: "none"
        });
      }
    }
  } else if (current > cible) {
    //CONTENU QUI DESCEND
    $('article').find('#section' + cible).css('top', '-120%');
    TweenLite.to($('article').find('#section' + cible), 1, {
      delay: .2,
      ease: Power3.easeInOut,
      top: "65px"
    });
    TweenLite.to($('article').find('#section' + current), 1, {
      ease: Power3.easeInOut,
      top: "120%"
    });
    //IF GALLERY EXIST, ANIM GALLERY
    if ($('.galerie').length == 1) {
      if (current == 2) {
        $('.galerie').find('.slider').removeClass('galleryTransition');
        TweenLite.to($('.galerie').find('.slider'), 1, {
          ease: Power2.easeInOut,
          top: "100%"
        });
        TweenLite.to($('.galerie').find('.showGallery'), .2, {
          opacity: 0,
          display: "none"
        });
      }
      if (cible == 2) {
        $('.galerie').find('.slider').css('top', '65px');
        $('.galerie').find('.slider').css('bottom', '100%');
        TweenLite.to($('.galerie').find('.slider'), 1, {
          delay: .2,
          ease: Power2.easeInOut,
          bottom: "60px",
          onComplete: myFunction
        });
        TweenLite.to($('.galerie').find('.showGallery'), .3, {
          delay: 1,
          opacity: 1,
          display: "block"
        });
      }
    }
    if ($('.galerie').length == 2) {
      if (current == 2) {
        $('.galerie-chateau').find('.slider').removeClass('galleryTransition');
        TweenLite.to($('.galerie').find('.slider'), 1, {
          ease: Power2.easeInOut,
          top: "100%"
        });
        TweenLite.to($('.galerie-chateau').find('.showGallery'), .2, {
          opacity: 0,
          display: "none"
        });
        $('.galerie-domaine').find('.slider').removeClass('galleryTransition');
        TweenLite.to($('.galerie').find('.slider'), 1, {
          ease: Power2.easeInOut,
          top: "100%"
        });
        TweenLite.to($('.galerie-domaine').find('.showGallery'), .2, {
          opacity: 0,
          display: "none"
        });
      }
      if (cible == 2) {
        $('.galerie-domaine').find('.slider').css('top', '10%');
        $('.galerie-domaine').find('.slider').css('bottom', '100%');
        TweenLite.to($('.galerie-domaine').find('.slider'), 1, {
          delay: .2,
          ease: Power2.easeInOut,
          bottom: "52%",
          onComplete: myFunction
        });
        TweenLite.to($('.galerie').find('.showGallery'), .3, {
          delay: 1,
          opacity: 1,
          display: "block"
        });
        //
        $('.galerie-chateau').find('.slider').css('top', '50%');
        $('.galerie-chateau').find('.slider').css('bottom', '100%');
        TweenLite.to($('.galerie-chateau').find('.slider'), 1, {
          delay: .2,
          ease: Power2.easeInOut,
          bottom: "10%",
          onComplete: myFunction
        });
        TweenLite.to($('.galerie-chateau').find('.showGallery'), .3, {
          delay: 1,
          opacity: 1,
          display: "block"
        });
      }
    }
  }
  current = parseInt(cible);
}

function myFunction() {
  $('.galerie').find('.slider').addClass('galleryTransition');
}

function initNav() {
  $('article').find("#start").on('click', function () {
    pressAside(2);
  });
  $('article').find("#next").on('click', function () {
    pressAside(3);
  });
  $('article').find("#next2").on('click', function () {
    pressAside(4);
  });
  $('article').find("#back-image").on('click', function () {
    pressAside(2);
  });
}

//SCREEN SIZE CONFIG
function resizing() {
  var winX = window.innerWidth;
  var winY = window.innerHeight - 100;
  var hauteur = $(".infos").height();

  var sections = $('.fs-section');
  if (winX > 768) {
    $('.go').css('height', winY - hauteur - 20 + "px");
    $('article').find(".fs-section").css('height', winY + 'px');
    $('article').find(".fs-section").css('width', winX - 45 + 'px');
    $('#content').css('height', winY + 100 + 'px');
  }
}

//GALLERY
function initGallery() {
  $('.showGallery').on('click', { cible: "unik" }, openGallery);
  $('.slider').on('click', { cible: "unik" }, openGallery);
  $('#btn-close-gallery').on('click', { cible: "unik" }, closeGallery);
  $('.back-gallery').on('click', { cible: "unik" }, closeGallery);
}

function initGalleryEntreprise() {
  $('.show-domaine').on('click', { cible: "domaine" }, openGallery);
  $('.slider-domaine').on('click', { cible: "domaine" }, openGallery);

  $('.show-chateau').on('click', { cible: "chateau" }, openGallery);
  $('.slider-chateau').on('click', { cible: "chateau" }, openGallery);

  $('#btn-close-gallery-domaine').on('click', { cible: "domaine" }, closeGallery);
  $('#btn-close-gallery-chateau').on('click', { cible: "chateau" }, closeGallery);
  //
  $('.back-domaine').on('click', { cible: "domaine" }, closeGallery);
  $('.back-chateau').on('click', { cible: "chateau" }, closeGallery);
}

function openGallery(e) {
  //alert(e.data.cible);

  currentGalerie = $('.galerie-' + e.data.cible);
  if (e.data.cible == "chateau") {
    TweenLite.to($('.galerie-domaine'), .4, {
      opacity: 0,
      display: "none"
    });
  }
  if (e.data.cible == "domaine") {
    TweenLite.to($('.galerie-chateau'), .4, {
      opacity: 0,
      display: "none"
    });
  }
  currentGalerie.find(".slider").addClass('z-change');
  currentGalerie.find("#slide1").addClass('slider1-open');
  if (galerieOpen == false) {
    $('.galerie-' + e.data.cible).find(".slider").addClass('galleryOpen');
    $('.galerie-' + e.data.cible).find(".nav-gallery").addClass('nav-open');
    galerieOpen = true;

    TweenLite.to($('.galerie-' + e.data.cible).find(".back-gallery"), .4, {
      opacity: 1,
      display: "block"
    });
    TweenLite.to($('.galerie-' + e.data.cible).find(".showGallery"), .4, {
      opacity: 0,
      display: "none"
    });
    //
    TweenLite.to($('.galerie-' + e.data.cible).find(".nav-left"), .4, {
      opacity: 1,
      display: "block",
      left: "40px",
      delay: .6
    });
    TweenLite.to($('.galerie-' + e.data.cible).find(".nav-right"), .4, {
      opacity: 1,
      display: "block",
      right: "120px",
      delay: .6
    });
  } else {}
}
//SLIDESHOW

function changeSlide(cible) {
  var currentSlide = currentGalerie.find('#slide' + currentDiapo);
  var currentBtn = currentGalerie.find('#slider-select' + currentDiapo);
  currentBtn.removeClass('activ-select');

  TweenLite.to(currentSlide, 0.6, {
    opacity: 0,
    display: "none"
  });
  currentDiapo = cible;
  currentSlide = currentGalerie.find('#slide' + currentDiapo);
  currentBtn = currentGalerie.find('#slider-select' + currentDiapo);
  currentBtn.addClass('activ-select');

  TweenLite.to(currentSlide, 0.6, {
    opacity: 1,
    display: "block"
  });
}

function initSlideshow(cible) {
  $('.galerie-' + cible).find('#slider-select1').addClass('activ-select');
  var base = $('.galerie-' + cible).find('.slider');

  var slideslieux = base.find('#diapos-lieux');
  //$('#li1').addClass('btn-activ');
  base.nbrSlide = base.children().length;
  totalSlide = base.nbrSlide;
  for (var i = 1; i <= base.nbrSlide; i++) {
    $('.galerie-' + cible).find('#slider-select' + i).on('click', function () {
      //console.log("j'appuie sur : " + this.dataset.id);
      changeSlide(this.dataset.id);
      //$('.galerie').find('#slider-select' + this.dataset.id).addClass('activ-select');
    });
  }

  $('.galerie-' + cible).find('.nav-right').on('click', function () {

    var currentDiapoNextLieux = base.find('#slide' + currentDiapo);
    var currentSelectLieux = $('.galerie-' + cible).find('#slider-select' + currentDiapo);
    currentSelectLieux.removeClass('activ-select');

    TweenLite.to(currentDiapoNextLieux, 0.6, {
      opacity: 0,
      display: "none"
    });
    if (currentDiapo < base.nbrSlide) {
      currentDiapo++;
    } else {
      currentDiapo = 1;
    }
    currentDiapoNextLieux = base.find('#slide' + currentDiapo);
    TweenLite.to(currentDiapoNextLieux, 0.6, {
      opacity: 1,
      display: "block"
    });
    currentSelectLieux = $('.galerie-' + cible).find('#slider-select' + currentDiapo);
    currentSelectLieux.addClass('activ-select');
  });

  $('.galerie-' + cible).find('.nav-left').on('click', function () {
    var currentDiapoPrevLieux = base.find('#slide' + currentDiapo);
    TweenLite.to(currentDiapoPrevLieux, 0.6, {
      opacity: 0,
      display: "none"
    });
    var currentSelectLieuxPrev = $('.galerie-' + cible).find('#slider-select' + currentDiapo);
    currentSelectLieuxPrev.removeClass('activ-select');

    if (currentDiapo > 1) {
      currentDiapo--;
    } else {
      currentDiapo = base.nbrSlide;
    }
    currentDiapoPrevLieux = base.find('#slide' + currentDiapo);
    TweenLite.to(currentDiapoPrevLieux, 0.6, {
      opacity: 1,
      display: "block"
    });
    currentSelectLieuxPrev = $('.galerie-' + cible).find('#slider-select' + currentDiapo);
    currentSelectLieuxPrev.addClass('activ-select');
  });
}

function myfunc2() {
  currentGalerie.find("#slide1").removeClass('slider1-open');
}

function closeGallery(e) {
  if (e.data.cible == "chateau") {
    TweenLite.delayedCall(.2, myfunc2);
    TweenLite.to($('.galerie-domaine'), .4, {
      opacity: 1,
      display: "block",
      delay: .5
    });
  }
  if (e.data.cible == "domaine") {
    TweenLite.delayedCall(.2, myfunc2);
    TweenLite.to($('.galerie-chateau'), .4, {
      opacity: 1,
      display: "block",
      delay: .5
    });
  }
  $('.galerie-' + e.data.cible).find(".slider").removeClass('galleryOpen');
  $('.galerie-' + e.data.cible).find(".slider").removeClass('z-change');
  $('.galerie-' + e.data.cible).find(".nav-gallery").removeClass('nav-open');

  changeSlide(1);
  galerieOpen = false;
  TweenLite.to($('.galerie-' + e.data.cible).find(".back-gallery"), .4, {
    opacity: 0,
    display: "none",
    delay: .4
  });
  TweenLite.to($('.galerie-' + e.data.cible).find(".showGallery"), .4, {
    delay: .5,
    opacity: 1,
    display: "block"
  });
  TweenLite.to($('.galerie-' + e.data.cible).find(".nav-left"), .4, {
    opacity: 0,
    left: "50px",
    display: "none"
  });
  TweenLite.to($('.galerie-' + e.data.cible).find(".nav-right"), .4, {
    opacity: 0,
    right: "130px",
    display: "none"
  });
}

//MENU TRIGGER
function initTrigger() {
  var isOpen = false;
  $(".trigger").on('click', function () {
    if (isOpen == false) {
      $('.nav-main').addClass('open');
      $('.back-menu').addClass('open-back');

      $('body').addClass('blok');
      TweenLite.to(".trigger span:nth-child(3)", 0.4, {
        ease: Power3.easeInOut,
        rotation: 45
      });
      TweenLite.to(".trigger span:nth-child(2)", 0.4, {
        ease: Power3.easeInOut,
        rotation: -45
      });
      TweenLite.to(".trigger span:nth-child(1)", 0.4, {
        ease: Power3.easeInOut,
        left: 100,
        opacity: 0,
        display: 'none'
      });
      TweenLite.to(".trigger span:nth-child(4)", 0.4, {
        ease: Power3.easeInOut,
        left: -100,
        opacity: 0,
        display: 'none'
      });

      isOpen = true;
    } else {
      TweenLite.to(".trigger span:nth-child(3)", 0.4, {
        ease: Power3.easeInOut,
        rotation: 0
      });
      TweenLite.to(".trigger span:nth-child(2)", 0.4, {
        ease: Power3.easeInOut,
        rotation: 0
      });
      TweenLite.to(".trigger span:nth-child(1)", 0.4, {
        ease: Power3.easeInOut,
        left: 22,
        opacity: 1,
        display: 'block'
      });
      TweenLite.to(".trigger span:nth-child(4)", 0.4, {
        ease: Power3.easeInOut,
        left: 24,
        opacity: 1,
        display: 'block'
      });
      $('.nav-main').removeClass('open');
      $('body').removeClass('blok');
      $('.back-menu').removeClass('open-back');
      isOpen = false;
    }
  });
}

function debouns(temps) {
  time = true;
  TweenLite.delayedCall(temps, timeOk);
}

function timeOk() {
  time = false;
}
//KEYWORD LISTEN
function initKeyboardListening() {
  console.log("test");
  $('body').keydown(function (e) {
    switch (e.which) {
      case 38:
        //KEY UP
        if (current > 1 && time == false && galerieOpen == false) {
          pressAside(current - 1);
          debouns(1.6);
        }
        break;
      case 40:
        //KEY DOWN
        if (current < maxSlice && time == false && galerieOpen == false) {
          pressAside(current + 1);
          debouns(1.6);
        }
        break;
      case 39:
        if (galerieOpen) {
          if (currentDiapo < totalSlide && time == false) {
            changeSlide(currentDiapo + 1);
            debouns(0.2);
          }
        }
        break;
      case 37:
        if (galerieOpen) {
          if (currentDiapo > 1 && time == false) {
            changeSlide(currentDiapo - 1);
            debouns(0.2);
          }
        }
        break;
    }
  });
  $(window).on('wheel', function (e) {
    var delta = e.originalEvent.deltaY;
    if (delta > 14) {
      if (galerieOpen == false) {
        if (current < maxSlice && time == false) {
          debouns(1.6);
          pressAside(current + 1);
        }
      } else {
        if (currentDiapo < totalSlide && time == false) {
          changeSlide(currentDiapo + 1);
          debouns(0.5);
        }
      }
    } else if (delta < -14) {
      if (galerieOpen == false) {
        if (current > 1 && time == false) {
          debouns(1.6);
          pressAside(current - 1);
        }
      } else {
        if (currentDiapo > 1 && time == false) {
          changeSlide(currentDiapo - 1);
          debouns(0.5);
        }
      }
    }
    return false;
  });
}

function initLoader() {
  var loade = $('.showbox');
  TweenLite.to(loade, .6, {
    opacity: 1,
    delay: .4
  });
  TweenLite.delayedCall(3, openSite);
}
/*function initTraiteur(){
  for(var i=2; i<=6; i++){
    var tempItem = $("#section1").find("#item"+i);
    
    TweenLite.to(tempItem.find(".cache"), .8, { ease: Power3.easeInOut, top: '100%', delay:(i*.4)+3});
  }
}*/

function openSite() {
  $('article').css("opacity", 1);
  $('.menu').css("opacity", 1);
  TweenLite.to('.preloader', .6, {
    opacity: 0,
    display: "none"
  });
  if ($('.accueil').length == 1) {

    var vid = document.getElementById('bgvid');
    vid.play();
  }
}
//INIT ON LOAD
$(function () {
  $(window).ready(function () {
    resizing();
    initLoader();
    //alert($('.galerie').length);
    var winX = window.innerWidth;
    if ($('.galerie').length == 1) {
      initSlideshow("unik");
      if (winX > 768) {
        initGallery();
      }
    }
    if ($('.galerie').length == 2) {
      initSlideshow("domaine");
      initSlideshow("chateau");
      if (winX > 768) {
        initGalleryEntreprise();
      }
    }
    initTrigger();
    if (window.innerWidth > 768 && $('.devis').length == 0) {
      initKeyboardListening();
    }
    if ($('#item1').length == 1) {
      //initTraiteur();
    }
    initNav();
    initPopup();
    if ($('aside').length == 1) {
      scrollBarInit();
    }
  });
});

$(window).resize(function () {
  resizing();
});

},{}]},{},[1])